import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import TradesLayer from "../../components/Trading/TradesLayer";

const PendingTradesPage = () => {
  return (
    <MasterLayout>
      <TradesLayer pageTitle="Pending Trades" reportType="PENDING" />
    </MasterLayout>
  );
};

export default PendingTradesPage;
